import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import { ContentsContextProvider } from './context/ContentContext';
import { QueryClientProvider,QueryClient } from 'react-query';
import { AuthContextProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();
root.render(
    <AuthContextProvider>
        <ContentsContextProvider>
            <QueryClientProvider client={queryClient}>

       
            <App />
            </QueryClientProvider>
        </ContentsContextProvider>
    </AuthContextProvider>


);

